import React from 'react';

interface IIconShareInvitation {
	color: string;
}

const IconShareInvitation = ({ color }: IIconShareInvitation) => {
	return (
		<svg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M11.1111 10.6077C10.5481 10.6077 10.0444 10.8338 9.65926 11.1878L4.37778 8.06128C4.41481 7.888 4.44444 7.71472 4.44444 7.5339C4.44444 7.35309 4.41481 7.17981 4.37778 7.00653L9.6 3.9101C10 4.28679 10.5259 4.52034 11.1111 4.52034C11.7005 4.52034 12.2657 4.28222 12.6825 3.85835C13.0992 3.43449 13.3333 2.85961 13.3333 2.26017C13.3333 1.66074 13.0992 1.08585 12.6825 0.661989C12.2657 0.238125 11.7005 0 11.1111 0C10.5217 0 9.95651 0.238125 9.53976 0.661989C9.12301 1.08585 8.88889 1.66074 8.88889 2.26017C8.88889 2.44098 8.91852 2.61426 8.95556 2.78754L3.73333 5.88398C3.33333 5.50728 2.80741 5.27373 2.22222 5.27373C1.63285 5.27373 1.06762 5.51186 0.650874 5.93572C0.234126 6.35958 0 6.93447 0 7.5339C0 8.13334 0.234126 8.70822 0.650874 9.13208C1.06762 9.55595 1.63285 9.79407 2.22222 9.79407C2.80741 9.79407 3.33333 9.56052 3.73333 9.18383L9.00741 12.3104C8.97037 12.4686 8.94815 12.6344 8.94815 12.8076C8.94815 14.0206 9.91852 15 11.1111 15C12.3037 15 13.2741 14.0206 13.2741 12.8076C13.2741 12.2242 13.0462 11.6646 12.6406 11.2521C12.2349 10.8395 11.6848 10.6077 11.1111 10.6077Z'
				fill='#808191'
			/>
		</svg>
	);
};

export default IconShareInvitation;
